import React from 'react'
import { useParams } from 'react-router-dom'
import Page from 'component/page-container'
import Comment from 'component/comment'
import moment from 'moment'
import 'moment/locale/ru'

import './style.css'

/* global API */

const EventSingleRoute = () => {

    const [event, setEvent] = React.useState({ 'participants': [] })
    const [commentList, setCommentList] = React.useState([])
    const { eventId } = useParams()

    React.useEffect(() => {

        // Event
        API.instance().getEvent(eventId).then(event => {
            event.dateStartFormatted = moment(event.dateStart).format('lll')
            event.dateEndFormatted = moment(event.dateStart).format('ll') === moment(event.dateEnd).format('ll')
                ? moment(event.dateEnd).format('LT')
                : moment(event.dateEnd).format('lll')
            setEvent(event)
        })

        // Event Comments
        API.instance().getEventCommentList(eventId).then(commentList => setCommentList(commentList))
    }, [eventId])

    return (
        <Page className="event-page" h1={event.title}>
            <div className="page__inner">
                <div className="event">
                    <div className="container">
                        {/* Calendar */}
                        {!!event.calendarLink &&
                            <p>
                                <small><a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={event.calendarLink}
                                >Подписаться на календарь «{event.process.title}» (webcal)</a>
                                </small>
                            </p>
                        }

                        {/* Event File */}
                        {!!event.fileLink &&
                            <p>
                                <small><a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={event.fileLink}
                                >Скачать файл .isc</a>
                                </small>
                            </p>
                        }
                    </div>
                    <p><br /></p>

                    {/* Description */}
                    {!!event.description &&
                        <div className="event__section">
                            <i className="fa fa-info event__section-icon" />
                            <div className="event__section-content">{event.description}</div>
                        </div>
                    }

                    {/* Location */}
                    {!!event.location &&
                        <div className="event__section">
                            <i className="fa fa-map event__section-icon" />
                            <div className="event__section-content">{event.location}</div>
                        </div>
                    }

                    {/* Participant List */}
                    {!!event.participants.length &&
                        <div className="event__section">
                            <i className="fa fa-users event__section-icon" />
                            <div className="event__section-content">
                                {event.participants.map(participant => (
                                    <span key={participant.id} className="event-participant">{participant.name} {participant.surname}</span>
                                ))}
                            </div>
                        </div>
                    }

                    {/* Date */}
                    <div className="event__section">
                        <i className="fa fa-calendar event__section-icon" />
                        <div className="event__section-content">{event.dateStartFormatted} — {event.dateEndFormatted}</div>
                    </div>

                    {/* Telegram */}
                    {(!!event.telegramChannelMessageId) &&
                        <div className="container">
                            Комментарии добавляют <a
                                target="_blank"
                                rel="noreferrer"
                                href={
                                    "https://t.me/c/" +
                                    event.process?.telegramChannelId.toString().substr(4) +
                                    "/" + event.telegramChannelMessageId
                                }
                            >к сообщению в Телеграме</a>.
                    </div>
                    }
                </div>
                <div className="comment-list">
                    {commentList.map(comment => (
                        <Comment key={comment.id} {...comment} />
                    ))}
                </div>
            </div>
        </Page>
    )
}

export default EventSingleRoute

